import { ApiServiceWithSettings, Audience, Authentication } from '../../common'
import { AxiosPromise } from 'axios'

export class BackofficePrintsApi extends ApiServiceWithSettings {
  updateTemplateContent(templateId: number, body: any): AxiosPromise<any> {
    return this.put(`/templates/${templateId}`, body, {
      authentication: Authentication.PUBLIC,
      aud: Audience.BACKOFFICE
    })
  }

  updateTemplate(templateId: number, body: any): AxiosPromise<any> {
    return this.patch(`/templates/${templateId}`, body, {
      authentication: Authentication.PUBLIC,
      aud: Audience.BACKOFFICE
    })
  }

  publishTemplate(version: number): AxiosPromise<any> {
    return this.post(
      `/templates/versions/${version}/publish`,
      {},
      {
        authentication: Authentication.PUBLIC,
        aud: Audience.BACKOFFICE
      }
    )
  }

  getTemplates(): AxiosPromise<any> {
    return this.get('/templates', {
      authentication: Authentication.PUBLIC,
      aud: Audience.BACKOFFICE
    })
  }

  getTemplatesByType(type: number): AxiosPromise<any> {
    return this.get(`/template-types/${type}/templates`, {
      authentication: Authentication.PUBLIC,
      aud: Audience.BACKOFFICE
    })
  }

  getTemplateVersions(templateId: number): AxiosPromise<any> {
    return this.get(`/templates/${templateId}/versions`, {
      authentication: Authentication.PUBLIC,
      aud: Audience.BACKOFFICE
    })
  }

  getTemplateTypes(): AxiosPromise<any> {
    return this.get('/template-types', {
      authentication: Authentication.PUBLIC,
      aud: Audience.BACKOFFICE
    })
  }
}
